export const isUserTooYoung = (
  ssn: string,
  now: Date = new Date(),
): boolean => {
  const dobDay = Number(ssn.slice(0, 2));
  const dobMonth = Number(ssn.slice(2, 4));
  const centurySign = ssn.slice(6, 7);
  const dobYear = Number(parseYear(centurySign) + ssn.slice(4, 6));
  const adultBirthday = new Date(dobYear + 15, dobMonth - 1, dobDay);

  return now < adultBirthday;
};

const parseYear = (centurySign: string): string => {
  switch (centurySign) {
    case "+":
      return "18";
    case "-":
      return "19";
    default:
      return "20";
  }
};
